import Vue from 'vue'
import moment from 'moment'
import { getLivingBroadcast } from '@/api/sso/liveBroadcastGroup'

const broadcast = {
  state: {
    key: 'broadcast',
    message: undefined,
    timer1: undefined, // 前15分钟提醒
    timer2: undefined, // 直播结束清空
    hidden: false // 今日内不再显示
  },
  mutations: {
    SET_MESSAGE (state, data) {
      const liveBeginTime = moment(data.liveBeginTime).valueOf()
      const liveEndTime = moment(data.liveEndTime).valueOf()

      console.log('直播信息：', {
        开始时间: moment(liveBeginTime).format('YYYY-MM-DD hh:mm:ss'),
        结束时间: moment(liveEndTime).format('YYYY-MM-DD hh:mm:ss')
      })

      state.message = {
        ...data,
        liveBeginTime,
        liveEndTime
      }
    },
    CLEAR_MESSAGE (state) {
      state.message = undefined
    },
    SET_TODAY_HIDDEN (state) {
      const tomorrow = moment()
        .add(1, 'days')
        .hours(0)
        .minutes(0)
        .seconds(0)
        .milliseconds(0)
        .valueOf()
      const now = moment().valueOf()
      state.hidden = true
      Vue.ls.set('broadcast_hidden', true, tomorrow - now)
    }
  },
  actions: {
    getLivingBroadcast ({ state, commit, dispatch }, that) {
      state.hidden = Vue.ls?.get('broadcast_hidden') || false
      return getLivingBroadcast().then(({ data }) => {
        if (data) {
          const liveEndTime = moment(data.liveEndTime).valueOf()

          if (liveEndTime > Date.now()) {
            commit('SET_MESSAGE', data)
            dispatch('countdown', that)
          } else {
            commit('CLEAR_MESSAGE')
          }
        }
      })
    },
    countdown ({ state, commit, dispatch }, that) {
      const { message } = state
      clearTimeout(state.timer1)
      clearTimeout(state.timer2)

      // if (message?.liveBeginTime - Date.now() > 15 * 60 * 1000) {
      //   state.timer1 = setTimeout(() => {
      //     clearTimeout(state.timer1)
      //     dispatch('notification', that)
      //   }, message?.liveBeginTime - Date.now() - 15 * 60 * 1000)
      // }

      state.timer2 = setTimeout(() => {
        clearTimeout(state.timer1)
        clearTimeout(state.timer2)
        that.$notification.close(state.key)
        commit('CLEAR_MESSAGE')
      }, message?.liveEndTime - Date.now())
    },
    notification ({ state, commit, dispatch }, that) {
      if (state.hidden) return

      const { message } = state
      const {
        params: { serviceId, systemCode }
      } = that.$route

      const handleClick = () => {
        if (!message?.liveId) {
          that.$message.error('直播数据异常')
          console.log(message)
          return
        }

        dispatch('entry/SetActiveAsync', {
          path: `/entry/${serviceId}/${systemCode}/sso-web#/company/helper/live-roadcast/details?liveId=${message.liveId}`
        })
      }

      that.$notification.open({
        message: '直播提醒',
        description: (h) => (
          <div>
            <a onClick={handleClick}>
              <img
                width="100%"
                src={message.liveCoverUrl || 'data:image/png;base64,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'}
                style="display: block;margin-top: 5px;"
              />
            </a>
            {/* <a-checkbox
              style="float: left;margin-top: 10px;margin-bottom: -5px;"
              onChange={(e) => { state.hidden = e.target.checked }}
            >
              <span style="margin-left: .5em;vertical-align: 1px;">今日内不再提示</span>
            </a-checkbox> */}
          </div>
        ),
        duration: 0,
        placement: 'bottomRight',
        key: state.key,
        onClose: () => {
          if (state.hidden) {
            commit('SET_TODAY_HIDDEN')
          }
        }
      })
    }
  }
}

export default broadcast
